import {colors} from '@purpose/ui/styles/theme/colors';
import {Status} from '../../types';

export const statusList = [
  Status.active,
  Status.inactive,
  Status.expired
  // Status.pending,
  // Status.underReview
];

export const statusFilterConfig = {
  [Status.active]: {
    text: 'BenefitStatus.active',
    value: Status.active
  },
  [Status.inactive]: {
    text: 'BenefitStatus.inactive',
    value: Status.inactive
  },
  [Status.expired]: {
    text: 'BenefitStatus.expired',
    value: Status.expired
  },
  [Status.pending]: {
    text: 'BenefitStatus.pending',
    value: Status.pending
  },
  [Status.underReview]: {
    text: 'BenefitStatus.underReview',
    value: Status.underReview
  }
};

export const styles = {
  active: {
    container: {
      backgroundColor: colors.primary.base,
      color: colors.white
    },
    text: {
      color: colors.white
    }
  },
  default: {
    container: {
      backgroundColor: colors.secondary[10],
      color: colors.primary.base,
      border: `1px solid ${colors.primary.base}`
    },
    text: {
      color: colors.primary.base
    }
  }
};
